// extracted by mini-css-extract-plugin
export default {"container":"toggle_container__gW4GX","active":"toggle_active__nsH4O","circle":"toggle_circle__1r24c","disabled":"toggle_disabled__xAyml"};